<!-- エラー画面 -->
<template>
  <div id="wrapper1">
    <img
      src="@/assets/common/img/with-kaunet_logo-overtime.png"
      alt="ウィズカウネット エージェントポータル"
      class="with-kaunet_logo-overtime"
    />

    <h2 class="com_mgb20 com_mgt100 com_fs26 com_medium1 com_center1">
      ただいまシステム運用時間外です
    </h2>

    <p class="com_mgb50 com_reguler1 com_center1">
      現在はシステム運用時間外のためご利用いただくことができません。
    </p>

    <p class="com_mgb50 com_fs17 com_reguler1 com_center1">
      システム運用時間<span class="com_fs26"> 8:00〜21:00</span>
    </p>

    <p class="com_copyright1 com_mgt100">© 2025 Kaunet</p>
  </div>
</template>
<script>
export default {
  name: "OverTimeComponent",
};
</script>
